import axios from '@/libs/axios'

export default {
  loadTable(pageConfig) {
    return axios.get('/financeiro/tipo_faixas', { params: pageConfig })
  },
  loadCombo() {
    return axios.get('/financeiro/tipo_faixas/lista')
  },
  insert(data) {
    return axios.post('/financeiro/tipo_faixas', data)
  },
  update(id, data) {
    return axios.put(`/financeiro/tipo_faixas/${id}`, data)
  },
  delete(id) {
    return axios.delete(`/financeiro/tipo_faixas/${id}`)
  },
}
